import { createSlice } from '@reduxjs/toolkit';

interface MobileMenuState {
    isOpen: boolean;
}

const initialState: MobileMenuState = {
    isOpen: false,
};

const mobileMenuSlice = createSlice({
    name: 'mobileMenu',
    initialState,
    reducers: {
        toggleMobileMenu: (state) => {
            state.isOpen = !state.isOpen;
        },
        openMobileMenu: (state) => {
            state.isOpen = true;
        },
        closeMobileMenu: (state) => {
            state.isOpen = false;
        },
    },
});

export const { toggleMobileMenu, openMobileMenu, closeMobileMenu } = mobileMenuSlice.actions;

export const mobileMenuSelector = (state: { mobileMenu: MobileMenuState }) => state.mobileMenu;

export default mobileMenuSlice.reducer;
